import styled, { css } from "styled-components";
import {
  PlacementType,
  placementMap,
  getOffsetByPlacement,
  getTooltipArrowPosition,
} from "../../constants/placement";

export enum TooltipTheme {
  Light = "light",
  Dark = "dark",
}
export const tooltipThemeBgMap = new Map<string, string>([
  [TooltipTheme.Light, "var(--task-eva-tooltip-light-bg)"],
  [TooltipTheme.Dark, "var(--task-eva-tooltip-dark-bg)"],
]);
export const tooltipThemeColorMap = new Map<string, string>([
  [TooltipTheme.Dark, "var(--task-eva-tooltip-dark-color)"],
  [TooltipTheme.Light, "var(--task-eva-tooltip-light-color)"],
]);

export const ToolTipWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: max-content;
`;
export const ToolTipContent = styled.div<{ color?: string }>`
  display: inline-block !important;
  border-radius: 2px;
  min-height: max-content;
  width: max-content;
  display: flex;
  padding: 3px 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  align-items: center;
  color: ${(p) => (p.color ? `${p.color} !important` : "default")};
`;
export const ToolTipArrow = styled.div`
  width: max-content;
  border-left: 5px solid transparent;
  border-top: 5px solid red;
  border-right: 5px solid transparent;
`;

export const ToolTipPopUpWrapper = styled.div<{
  placement: PlacementType;
  offsetX: string;
  offsetY: string;
  mode: string;
  maxWidth: string;
}>`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 20001;
  word-wrap: break-word;
  ${(p) =>
    p.maxWidth &&
    css`
      .tooltip-content {
        max-width: ${p.maxWidth} !important;
      }
    `}
  ${(p) => placementMap.get(p.placement)};
  ${({ placement, offsetX, offsetY }) =>
    getOffsetByPlacement(placement, offsetX, offsetY, true)};
  ${ToolTipContent} {
    ${(p) => css`
      background: ${tooltipThemeBgMap.get(p.mode)};
      color: ${tooltipThemeColorMap.get(p.mode)};
    `};
  }
  ${ToolTipArrow} {
    border-top: 5px solid ${(p) => tooltipThemeBgMap.get(p.mode)};
    ${(p) => getTooltipArrowPosition(p.placement)};
  }
`;
